module.exports = __webpack_public_path__ + "img/empty.82bdc026.svg";